<template>
  <section class="sal-card">
    <div class="sal-section-head">
      <h1 class="sal-section-title">Resumen de Reporte</h1>
    </div>

    <div class="sal-summary-list">
      <div class="sal-summary-row">
        <i class="bi bi-calendar3" aria-hidden="true"></i>
        <span>Fecha</span>
        <strong>{{ form.fecha ? formatFecha(form.fecha) : "00/00/0000" }}</strong>
      </div>

      <div class="sal-summary-row">
        <i class="bi bi-person" aria-hidden="true"></i>
        <span>Operador</span>
        <strong>{{ form.operadorLabel || "—" }}</strong>
      </div>

      <div class="sal-summary-row">
        <i class="bi bi-box-seam" aria-hidden="true"></i>
        <span>Producto</span>
        <strong>{{ form.productoLabel || "—" }}</strong>
      </div>

      <!-- ✅ Color con hex real del backend -->
      <div class="sal-summary-row">
        <i class="bi bi-palette" aria-hidden="true"></i>
        <span>Color</span>
        <strong class="sal-summary-color-value">
          <!-- ← agregar clase -->
          <span
            v-if="form.colorHex"
            class="sal-color-swatch"
            :style="{ background: form.colorHex }"
          ></span>
          {{ form.colorLabel || "—" }}
        </strong>
      </div>

      <div class="sal-summary-row">
        <i class="bi bi-droplet" aria-hidden="true"></i>
        <span>Aditivo</span>
        <strong>{{ form.aditivo ? "SÍ" : "NO" }}</strong>
      </div>

      <!-- ✅ Piezas no kg -->
      <div class="sal-summary-row">
        <i class="bi bi-stack" aria-hidden="true"></i>
        <span>Cantidad</span>
        <strong>
          {{
            form.cantidad !== "" && form.cantidad !== undefined
              ? `${form.cantidad} pzs`
              : "0 pzs"
          }}
        </strong>
      </div>

      <div class="sal-summary-row sal-summary-row--codes">
        <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
        <span>Códigos</span>
        <div class="sal-summary-codes-value">
          <div
            v-if="form.codigosError && form.codigosError.length > 0"
            class="sal-summary-codes"
          >
            <div v-for="cod in form.codigosError" :key="cod.value" class="sal-code-pill">
              <span class="sal-code-pill-num">{{ cod.codigo }}</span>
              <span class="sal-code-pill-label">{{ cod.label }}</span>
            </div>
          </div>
          <strong v-else class="sal-summary-empty">—</strong>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  form: {
    type: Object,
    required: true,
  },
});

function formatFecha(fecha) {
  if (!fecha) return "00/00/0000";
  const [y, m, d] = fecha.split("-");
  return `${d}/${m}/${y}`;
}
</script>
